<template>
    <v-container fluid tag="section">
        <material-card color="primary" icon="mdi-watermark">
            <template #title v-if="id">
                <Банер>: <b>{{ series.name }} #{{ id }}</b> <br>
            </template>
            <template #title v-else>
                Нова серія
            </template>
            <v-row class="pl-3 pr-3">
                <v-col cols="12" sm="6">
                    <ButtonComeBack />
                </v-col>

                <!--Зберегти: "механіка" + "опис-->
                <v-col cols="12" sm="6" class="text-right">
                    <v-btn color="primary" min-width="150" @click="updateseries()">
                        Зберегти
                    </v-btn>
                </v-col>
            </v-row>

            <!-- {{ series }} -->
            <v-row>
                <v-col cols="12">
                    <v-form class="form-series-edit" lazy-validation v-model="isValidForm" ref="formseries">

                        <!-- ----------------------------- ТАБИ головні ----------------------------- -->
                        <v-tabs v-model="tabMainActive" :show-arrows="true" dark background-color="primary">
                            <v-tab v-for="tab in tabsMain" :key="tab.id" :eager="true">
                                {{ tab.name }}
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tabMainActive" :touchless="true">
                            <!--Таб Опис-->
                            <v-tab-item :eager="true">
                                <v-row>
                                    <v-col cols="12" lg="6">
                                        <v-col cols="12" v-if="series.id">
                                            <v-text-field label="ID" v-model="series.id" readonly />
                                        </v-col>
                                        <!-- Проєкт -->
                                        <v-col cols="12">
                                            <v-select v-model="series.project_id" label="Проекти" cache-items
                                                item-text="name" item-value="id" :items="projectList" required
                                                :rules="[v => !!v > 0 || errorRequired]"
                                                prepend-icon="mdi-format-list-bulleted-type">
                                            </v-select>
                                        </v-col>
                                        <!-- URL -->
                                        <v-col cols="12">
                                            <v-text-field label="URL" v-model="series.url" />
                                        </v-col>
                                        <!-- Позиція -->
                                        <v-col cols="12">
                                            <v-text-field label="Позиція" v-model="series.order" />
                                        </v-col>
                                        <!-- Включена чекбокс -->
                                        <v-col cols="12">
                                            <v-switch v-model="series.is_active" label="Включена" />
                                        </v-col>
                                        <!-- ----------------------------- ТАБИ локалізація ----------------------------- -->
                                        <v-col cols="12">
                                            <v-tabs v-model="tab">
                                                <v-tab v-for="local in localization" :key="local.lang_key">
                                                    {{ local.name }}
                                                </v-tab>
                                            </v-tabs>
                                        </v-col>

                                        <!--Содержимое табов-->
                                        <v-col cols="12">
                                            <v-tabs-items v-model="tab">
                                                <v-tab-item v-for="(item, index) in series.langs" :key="item.lang_key"
                                                    :eager="true">
                                                    <template>
                                                        <!-- Назва -->
                                                        <v-text-field label="Назва" v-model="item.name"
                                                            :rules="[v => true]" />
                                                        <!-- Коротка назва -->
                                                        <v-text-field label="Коротка назва" v-model="item.short_name"
                                                            :rules="[v => true]" />
                                                        <!--Текст-->
                                                        <v-textarea label="Текст" v-model="item.text"
                                                            :rules="[v => true]" />
                                                        <!-- Title -->
                                                        <v-text-field label="Title" v-model="item.seo_title" />
                                                        <!-- Description -->
                                                        <v-textarea label="Description"
                                                            v-model="item.seo_description" />
                                                        <!-- SEO-текст -->
                                                        <v-textarea label="SEO-текст" v-model="item.seo_text" />
                                                        <!--Изображение-->
                                                        <ImageUpload v-model="item.list_image"
                                                            label="Зображення для списку"
                                                            @image-upload:change="changeImage($event, item.lang_key, 'series_list_image')"
                                                            :imageBaseUrl="imageBaseUrl" />
                                                        <ImageUpload v-model="item.page_image"
                                                            label="Зображення для сторінки"
                                                            @image-upload:change="changeImage($event, item.lang_key, 'series_page_image')"
                                                            :imageBaseUrl="imageBaseUrl" />
                                                    </template>
                                                </v-tab-item>
                                            </v-tabs-items>
                                        </v-col>
                                    </v-col>
                                </v-row>
                            </v-tab-item>

                            <!--Таб Товари-->
                            <v-tab-item :eager="true">
                                <v-row>
                                    <v-col cols="12" class="ma-4" lg="6">
                                        <div class="text-h3">Характеристика ST</div>
                                        <v-data-table :headers="headersSt" :items="itemsSt" class="elevation-1"
                                            disable-pagination hide-default-footer>
                                            <template v-slot:item.delete="{ item }">
                                                <v-btn icon @click="deleteStProp(item)">
                                                    <v-icon color="red">mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                        <v-btn color="primary" class="mt-3" @click="openPropsDialog = true"
                                            :disabled="!series.id">
                                            Додати характеристику
                                        </v-btn>
                                        <div class="text-h3 mt-5">Товари Серії</div>
                                        <v-data-table :headers="headersProducts" :items="itemsProducts"
                                            class="elevation-1">
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>

                        <Preloader v-if="isSending" />
                        <DialogConfitmDelete ref="dialogConfirmDelete" />
                        <v-dialog v-model="openPropsDialog" max-width="600px">
                            <template v-slot:activator="{ on, attrs }">
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">Додати характеристику ST</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-autocomplete :items="propsItems" hide-no-data outlined v-model="propsSelected"
                                        :loading="isLoading" :search-input.sync="searchProps"
                                        label="Оберіть Характеристику" placeholder="Почніть вводити для пошуку"
                                        @change="getPropsValues()" prepend-icon="mdi-database-search" return-object>
                                    </v-autocomplete>
                                    <!-- <v-select :items="propsValuesItems" hide-no-data outlined
                                        v-model="propsValueSelected" label="Оберіть Значення" return-object
                                        prepend-icon="mdi-alpha-v">
                                    </v-select> -->
                                    <v-autocomplete :items="propsValuesItems" hide-no-data outlined
                                        v-model="propsValueSelected" label="Оберіть Значення" return-object
                                        prepend-icon="mdi-alpha-v" :search-input.sync="searchPropsValues"
                                        placeholder="Почніть вводити для пошуку">
                                    </v-autocomplete>


                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" text @click="addPropsValue()"> Додати </v-btn>
                                    <v-btn color="blue darken-1" text @click="openPropsDialog = false">
                                        Закрити
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-form>
                </v-col>
            </v-row>
        </material-card>
    </v-container>
</template>


<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { IMAGE_BASE_URL } from '@/env.config';

export default {
    name: 'PageseriesProfile',
    props: {
        id: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            enabled: false,
            series: {
                langs: [],
                is_active: true,
                order: null,
                url: '',
                id: null,
                project_id: null
            },
            items: [],
            // Нужно vuetify для валидации формы
            isValidForm: true,
            // Сообщение об ошибке для обязательных полей
            errorRequired: `Це поле обов'язкове`,
            // Указывает на то что выполняется отправка формы
            isSending: false,
            // Изображения для отправки 
            imagesToSend: {},
            seriesImage: null,//'/assets/img/seriess/2v9aj5numrmm1g710skx3wmy0wt3m5sp.png',
            // Базовый url картинки
            imageBaseUrl: `${IMAGE_BASE_URL}series/`,
            tab: 0,
            projectList: [],
            tabsMain: [
                { name: "Опис", id: 'description' },
                { name: "Товари", id: 'products' },
            ],
            tabMainActive: 0,
            itemsPerPage: 50,
            headersSt: [
                { text: 'ID', value: 'props_id' },
                { text: 'Назва', value: 'props_name' },
                { text: 'ID значення', value: 'props_value_id' },
                { text: 'Назва значення', value: 'props_value_name' },
                { text: 'Видалити', value: 'delete' },
            ],
            itemsSt: [],
            headersProducts: [
                { text: 'Код тайфун', value: 'typhoon_id' },
                { text: 'Назва товару', value: 'name' },
                { text: 'URL', value: 'url' },
            ],
            itemsProducts: [],
            openPropsDialog: false,
            propsItems: [],
            searchProps: null,
            isLoading: false,
            propsSelected: null,
            propsValueSelected: null,
            propsValuesItems: [],
            searchPropsValues: null,

        }
    },
    computed: {
        ...mapGetters(['snackbar', 'localization', 'isManager', 'isAdmin']),
        firstLevelCatalog() {
            const cat = this.catalog.filter(item => item.level == 1).map(item => ({ ...item, children: [] }));
            // додати корінь з id 0
            return [{ id: 0, name: 'Меню сайту', level: 0, children: cat }];
        },
        someImageChecked() {
            return this.series.langs.some(item => item.image) || this.imagesToSend && Object.keys(this.imagesToSend).length;
        }
    },
    async mounted() {
        await this.init();
    },
    watch: {
        tabMainActive(newVal) {
            // завантажуємо характеристики та товари
            if (newVal == 1 && this.series.id) {
                this.getStProps();
                this.getLinkedProducts();
            }
        },
        async searchProps(val) {
            this.isLoading = true;
            if (!val || val.length < 2) {
                this.propsItems = [];
                this.isLoading = false;
                return;
            }
            try {
                let { data } = await HTTP.post('/search-st-props', { query: val });
                this.propsItems = data.content;
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
            } finally {
                this.isLoading = false;
            }
        },
        async searchPropsValues(val) {
            this.isLoading = true;
            if (!val || val.length < 2) {
                this.propsValuesItems = [];
                this.isLoading = false;
                return;
            }
            try {
                console.log(this.propsSelected);
                let { data } = await HTTP.post('/search-st-props-values', { query: val, prop_id: this.propsSelected.value });
                this.propsValuesItems = data.content;
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
            } finally {
                this.isLoading = false;
            }
        },

    },
    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getLocalization']),
        async init() {
            await this.getLocalization();
            await this.getProjectList();
            if (this.id) {
                const data = await this.getSeries();
            } else {
                this.series.langs = this.localization.map((el) => {
                    return {
                        lang_key: el.lang_key,
                        lang_name: el.name,
                        name: '',
                        short_name: '',
                        text: '',
                        seo_title: '',
                        seo_description: '',
                        seo_text: '',
                        list_image: '',
                        page_image: '',
                    };
                });
            }

        },
        async runProcessImagesSend(id) {
            let errors = '';
            for (let key in this.imagesToSend) {
                let item = this.imagesToSend[key];
                let queryParams = {
                    lang_key: key,
                    object_image_id: id,
                    image_type: 'series_image',
                };
                let result = await item.sendImage(queryParams);
                // Если при загрузке изображений были - показать попап
                if (!result.error) {
                    delete this.imagesToSend[key];
                } else {
                    errors += `${result.error}</br>`;
                    this.setSnackbar({ type: 'error', text: errors });
                }
            }
            this.isSending = false;
        },
        async getSeries() {
            let { data } = await HTTP.post('/get-series', { 'id': this.$route.params.id });
            this.series = data.content;
            this.series.langs.map(item => {
                item.list_image = item.list_image ? `${this.imageBaseUrl}${item.list_image}` : '';
                item.page_image = item.page_image ? `${this.imageBaseUrl}${item.page_image}` : '';
                return item;
            });
            return data.content;
        },
        async getPropsValues() {
            this.isLoading = true;
            try {
                let { data } = await HTTP.post('/get-st-props-values', { prop_id: this.propsSelected.value });
                this.propsValuesItems = data.content;
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
            } finally {
                this.isSending = false;
            }
        },
        async addPropsValue() {
            if (!this.propsSelected || !this.propsValueSelected) {
                this.setSnackbar({ type: 'error', text: 'Потрібно обрати характеристику та її значення' });
                return;
            }
            this.isSending = true;
            try {
                await HTTP.post('/add-series-st-props', {
                    series_id: this.series.id,
                    props_id: this.propsSelected.value,
                    props_value_id: this.propsValueSelected.value
                });
                this.setSnackbar({ type: 'success', text: 'Успішно додано' });
                this.openPropsDialog = false;
                this.propsSelected = null;
                this.propsValueSelected = null;
                this.propsValuesItems = [];
                this.getStProps();
                this.getLinkedProducts();
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
            } finally {
                this.isSending = false;
            }
        },

        // Изменить список картинок 
        changeImage(data, langKey, imageType) {
            const key = `${langKey}.${imageType}`;
            if (data.action) {
                this.imagesToSend[key] = {
                    sendImage: data.sendImage
                };
            } else {
                delete this.imagesToSend[key];
            }
        },
        async getStProps() {
            this.isSending = true;
            try {
                let { data } = await HTTP.post('/get-series-st-props', { series_id: this.series.id });
                this.itemsSt = data.content;
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
            } finally {
                this.isSending = false;
            }
        },
        async getLinkedProducts() {
            this.isSending = true;
            try {
                let { data } = await HTTP.post('/get-linked-products', { series_id: this.series.id, items_per_page: this.itemsPerPage });
                this.itemsProducts = data.content;
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
            } finally {
                this.isSending = false;
            }
        },
        async deleteStProp(item) {
            let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
            if (!isConfirmDelete) return;
            this.isSending = true;

            try {
                await HTTP.post('/delete-series-st-props', { props_id: item.props_id, series_id: this.series.id, props_value_id: item.props_value_id });
                await this.getStProps();
                this.getLinkedProducts();
                this.setSnackbar({ type: 'success', text: 'Успішно видалено' });
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
            } finally {
                this.isSending = false;
            }
        },
        async updateseries() {
            let queryParams = { ...this.series, positions: this.positions };

            if (this.isSending) return;
            if (!this.$refs.formseries.validate()) {
                this.setSnackbar({ type: 'error', text: 'Форма заповнена не вірно' });
                return;
            }

            // if (!this.someImageChecked) {
            //     this.setSnackbar({ type: 'error', text: 'Потрібно завантажити хоча б одне зображення' });
            //     return;
            // }

            this.isSending = true;

            try {
                const { data } = await HTTP.post(this.series.id ? '/update-series' : '/create-series', queryParams);

                let isImages = Object.keys(this.imagesToSend)?.length;

                this.setSnackbar({
                    type: 'success',
                    text: `Данні оновлено. ${isImages ? 'Виконується завантаження зображень.' : ''}`
                });

                if (!isImages) {
                    this.isSending = false;
                }
                // сделал через $watch потомучто setSnackbar сделан через "mutation" (не может вернуть промис)
                const unwatch = this.$watch('snackbar.model', function (newVal, oldVal) {
                    unwatch();
                    // Запускаем загрузку изображений
                    if (isImages) {
                        this.runProcessImagesSend(this.series.id || data.content.insertId);
                    }
                });
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
                this.isSending = false;
            }
        },

        // Запускает процесс отравки изображений, отправкой занимается "ImageUpload"
        async runProcessImagesSend(id) {
            let errors = '';
            for (let key in this.imagesToSend) {
                const [keyLang, keyImageType] = key.split('.');
                let item = this.imagesToSend[key];
                let queryParams = {
                    lang_key: keyLang,
                    object_image_id: id,
                    image_type: keyImageType,
                };

                let result = await item.sendImage(queryParams);
                // Если при загрузке изображений были - показать попап
                if (!result.error) {
                    delete this.imagesToSend[key];
                } else {
                    errors += `${result.error}</br>`;
                    this.setSnackbar({ type: 'error', text: errors });
                }
            }
            this.isSending = false;
        },
        // Получить список проектов
        async getProjectList() {
            try {
                let { data } = await HTTP.post('/get-projects');
                this.projectList = data.content;
            } catch (error) {
                console.warn(error);
            }
        },

    },
}
</script>

<style scoped lang="sass">
  .form-series-edit
    position: relative
  </style>
